import { css } from 'styled-components'
import { minMq, maxMq } from '../../shared/styles/breakPoints'
import variables from '../../shared/styles/variables'
// import variables from '../../shared/styles/variables'


const topImg = css`
  display: block;
  margin: 30px auto 0;
  width: min(70vw, 560px);

  ${maxMq('MD')} {
    margin-bottom: 40px;
    margin-top: 15px;
  }
`

const topImgLine = css`
  border: 1px solid ${variables.OUTER_FRAME};
`

const listTitle = css`
  background-color: ${variables.LIGHT_BLUE};
  font-size: 1.8rem;
  font-weight: 500;
  padding: 10px;
  
  ${minMq('MD')} {
    font-size: 2rem;
  }
`

const listTitleNone = css`
  background-color: ${variables.LIGHT_BLUE};
  height: 47px;
  
  ${minMq('MD')} {
    height: 50px;
  }
`

const pdfLink = css`
  background-color: ${variables.LIGHT_YELLOW};
`


export const style = {
  topImg,
  topImgLine,
  listTitle,
  listTitleNone,
  pdfLink
}
